<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...$$props}
>
  <g id="Group 774">
    <path id="Vector 12" d="M8 5.58618V15" stroke="black" stroke-width="2" stroke-linecap="round" />
    <path id="Vector 13" d="M15 1L1 1" stroke="black" stroke-width="2" stroke-linecap="round" />
    <path
      id="Icon"
      d="M3.5 8.24145L8 3.89663L12.5 8.24146"
      stroke="#111111"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</svg>
